module.exports = __webpack_public_path__ + "media/images/unlock-8c3dd1ea4be4be60eb05514300c3903e.svg";